type GtagCommand = "config" | "event" | "consent" | "js" | "set";

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    gtag: (...args: [GtagCommand, ...unknown[]]) => void;
  }
}

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GOOGLE_ID;

export const CONSENT_COOKIE_NAME = "cookie_consent";

export function getConsentStatus(): "granted" | "denied" | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${CONSENT_COOKIE_NAME}=`));
  if (!match) return null;
  return match.split("=")[1] as "granted" | "denied";
}

export function setConsentCookie(value: "granted" | "denied") {
  const maxAge = 182 * 24 * 60 * 60; // 6 months
  document.cookie = `${CONSENT_COOKIE_NAME}=${value};path=/;max-age=${maxAge};SameSite=Lax`;
}

export function updateConsent(status: "granted" | "denied") {
  setConsentCookie(status);
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: status,
    });
  }
}

export function resetConsent() {
  document.cookie = `${CONSENT_COOKIE_NAME}=;path=/;max-age=0`;
  window.dispatchEvent(new Event("cookie-consent-reset"));
}

export function trackPageView(url: string) {
  if (typeof window.gtag !== "function" || !GA_MEASUREMENT_ID) return;
  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: url,
  });
}
